'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export function useSocket() {
    return useContext(SocketContext);
}

export function SocketProvider({ children }) {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Use direct backend URL to avoid Next.js rewrite WebSocket issues
        // If testing on LAN, use the current window hostname to reach the backend
        let backendUrl = process.env.NEXT_PUBLIC_API_URL;
        if (!backendUrl) {
            backendUrl = typeof window !== 'undefined'
                ? (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
                    ? `${window.location.protocol}//${window.location.hostname}:3000`
                    : `${window.location.protocol}//${window.location.hostname}`)
                : 'http://localhost:3000';
        }

        const newSocket = io(backendUrl, {
            path: '/api/stream-relay',
            transports: ['websocket'],
            upgrade: true,
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
            timeout: 20000,
        });

        newSocket.on('connect', () => {
            console.log('[Socket] Connected to:', backendUrl, '| Transport:', newSocket.io.engine?.transport?.name);
        });

        newSocket.on('disconnect', (reason) => {
            console.log('[Socket] Disconnected:', reason);
        });

        newSocket.on('connect_error', (err) => {
            console.error('[Socket] Connection error:', err.message, '| URL:', backendUrl);
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
}

